import { formatMcpBannerMessage } from '../../lib/mcp-tool-utils';

type McpWarningBannerProps = {
  warnings: string[];
};

function McpWarningBanner({ warnings }: McpWarningBannerProps) {
  if (!warnings.length) {
    return null;
  }

  return (
    <div
      className="mb-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-amber-900"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-2">
        <span className="text-base leading-none mt-0.5" aria-hidden>
          ⚠
        </span>
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-amber-800">
            MCP unavailable
          </p>
          <p className="mt-1 text-xs leading-relaxed text-amber-900">
            {formatMcpBannerMessage(warnings)}
          </p>
        </div>
      </div>
    </div>
  );
}

export default McpWarningBanner;
